import React, { useEffect, useRef, useState } from 'react';
import { IconButton, ListItem, ListItemButton, ListItemText, CircularProgress, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFieldApi } from '@truvity/widget__forms';

import { CredentialDid } from '../../../../../types';
import { LinkedCredentialsWidget, Preview } from '../../../../widgets/linkedCredentials';
import { CredentialPreview } from '../CredentialPreview';

export type CredentialCardProps = {
    value: CredentialDid;
    onDelete: () => void;
    isDisabled?: boolean;
};

export const CredentialCard = ({ value, onDelete, isDisabled }: CredentialCardProps) => {
    const { getWidgetApi } = useFieldApi();
    const {
        getCredentialPreview,
        options: { walletDid, entityDid },
    } = getWidgetApi(LinkedCredentialsWidget);

    const prevValue = useRef(value);

    const [isLoading, setIsLoading] = useState(false);
    const [credentialPreview, setCredentialPreview] = useState<Preview>();

    useEffect(() => {
        (async () => {
            if (prevValue.current !== value || (credentialPreview == null && !isLoading)) {
                prevValue.current = value;

                setIsLoading(true);
                try {
                    setCredentialPreview(await getCredentialPreview(value));
                } catch (e) {
                    setCredentialPreview('N/A');
                } finally {
                    setIsLoading(false);
                }
            }
        })();
    }, [credentialPreview, getCredentialPreview, isLoading, value]);

    // RENDER
    const renderDeleteControl = () => {
        if (isDisabled) return null;

        return (
            <IconButton edge="end" onClick={onDelete}>
                <DeleteIcon />
            </IconButton>
        );
    };

    return (
        <CredentialPreview credentialId={value} walletDid={walletDid} entityDid={entityDid}>
            {({ showPreview }) => (
                <Paper>
                    <ListItem secondaryAction={renderDeleteControl()} disablePadding>
                        <ListItemButton onClick={showPreview}>
                            <ListItemText
                                primary={isLoading ? <CircularProgress size={16} /> : credentialPreview}
                                secondary="Select for preview"
                            />
                        </ListItemButton>
                    </ListItem>
                </Paper>
            )}
        </CredentialPreview>
    );
};
